import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const McpAppsContext = createContext({ client: null });

export const useMcpApps = () => {
  return useContext(McpAppsContext);
};

export const MCPAppsProvider = ({ children = null, mcpBaseUrl = null, sandboxHtmlUrl }) => {
  const mcpConfig = useMemo(() => {
    return { mcpBaseUrl, sandboxHtmlUrl };
  }, [mcpBaseUrl, sandboxHtmlUrl]);

  return (
    <McpAppsContext.Provider
      value={{
        mcpConfig,
      }}
    >
      {children}
    </McpAppsContext.Provider>
  );
};

MCPAppsProvider.propTypes = {
  children: PropTypes.node,
  mcpBaseUrl: PropTypes.string,
  sandboxHtmlUrl: PropTypes.string.isRequired,
};
